import moment from "moment";

export const dates = {
    mapToDate: (date) => {
        return moment(date).format('YYYY-MM-DD')
    },
    mapToDateUsingFormat: (date, format) => {
        return moment(date, format).format('YYYY-MM-DD')
    },
    mapToDateTime: (date) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    mapToTimeNoSecs: (date) => {
        return moment(date).format('HH:mm')
    }
}